import ButtonCustom from '@/components/common/ui/button';
import DialogCustom from '@/components/common/ui/dialog';
import { DATE_TIME_FORMAT } from '@/shared/constants';
import { HistoryChangePlanType } from '@/types/plan';
import dayjs from 'dayjs';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  data: HistoryChangePlanType[];
};
const PopupHistoryChangePlan = ({ isOpen, onClose, data }: Props) => {
  return (
    <DialogCustom
      header={'プラン変更履歴'}
      visible={isOpen}
      className="w-[700px]"
      headerClassName="border-b border-gray-200 !py-[13px]"
      contentClassName="border-b border-gray-200 !p-[16px] !text-[16px] !leading-[24px] text-center text-gray-900 whitespace-pre-line"
      onHide={onClose}
      footer={
        <div className="flex gap-4 justify-end">
          <ButtonCustom
            type="button"
            className="!rounded-md"
            severity="secondary"
            onClick={onClose}
          >
            キャンセル
          </ButtonCustom>
        </div>
      }
    >
      <div className="max-w-3xl mx-auto border border-gray-300 rounded-xl overflow-hidden">
        <div className="flex bg-gray-100 text-sm font-semibold text-gray-700 border-b border-gray-300">
          <div className="w-1/2 px-4 py-3 text-left border-r border-gray-300">変更日付</div>
          <div className="w-1/2 px-4 py-3 text-left">プラン</div>
        </div>

        {data.length === 0 && (
          <div className="flex justify-center items-center text-gray-500">
            <p className="text-sm py-4">データがありません。</p>
          </div>
        )}

        {data.length > 0 && data.map((item, index) => (
          <div
            key={index}
            className={`flex text-md ${
              index !== data.length - 1 ? 'border-b border-gray-200' : ''
            }`}
          >
            <div className="w-1/2 px-4 py-3 text-left border-r border-gray-300">{dayjs(item.changed_at).format(DATE_TIME_FORMAT.DATE_TIME)}</div>
            <div className="w-1/2 px-4 py-3 text-left">{item.plan_name}</div>
          </div>
        ))}
      </div>
    </DialogCustom>
  );
};

export default PopupHistoryChangePlan;
